import React from 'react';
import { Typography, Grid, TextField, Box, Divider, alpha, useTheme } from '@mui/material';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';

interface TransactionFormProps {
    transaction: {
        loanaccount: number;
        svaccount: number;
        l9payment: number;
        staffsalary: number;
        drivertips: number;
        driverfooding: number;
        extraexpenses: number;
        remarks: string;
    };
    handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    totalExpense: () => number;
}

const expenseFields = [
    { label: 'Load Account Transfer', name: 'loanaccount' },
    { label: 'SV Account Transfer', name: 'svaccount' },
    { label: 'L9 Payments', name: 'l9payment' },
    { label: 'Staff Salary', name: 'staffsalary' },
    { label: 'Driver Tips', name: 'drivertips' },
    { label: 'Driver Fooding', name: 'driverfooding' },
    { label: 'Extra Expenses', name: 'extraexpenses' },
];

export const TransactionForm = ({ transaction, handleChange, totalExpense }: TransactionFormProps) => {
    const theme = useTheme();

    return (
        <Box>
            {/* Section label */}
            <Typography
                variant="subtitle2"
                color="text.secondary"
                sx={{ mb: 2, fontWeight: 600, letterSpacing: 0.5, textTransform: 'uppercase', fontSize: '0.7rem' }}
            >
                Today's Expenses
            </Typography>

            <Grid container spacing={1.5}>
                {expenseFields.map((field) => (
                    <Grid item xs={6} key={field.name}>
                        <Typography variant="caption" color="text.secondary" fontWeight={600} display="block" mb={0.4}>
                            {field.label}
                        </Typography>
                        <TextField
                            fullWidth
                            size="small"
                            name={field.name}
                            type="number"
                            value={transaction[field.name as keyof typeof transaction]}
                            onChange={handleChange}
                            inputProps={{ min: 0 }}
                        />
                    </Grid>
                ))}

                <Grid item xs={12}>
                    <Typography variant="caption" color="text.secondary" fontWeight={600} display="block" mb={0.4}>
                        Remarks
                    </Typography>
                    <TextField
                        fullWidth
                        size="small"
                        name="remarks"
                        type="text"
                        value={transaction.remarks}
                        onChange={handleChange}
                        placeholder="Optional remarks..."
                    />
                </Grid>
            </Grid>

            <Divider sx={{ mt: 2, mb: 1.5 }} />

            {/* Total */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    px: 2,
                    py: 1.25,
                    borderRadius: 2,
                    bgcolor: alpha(theme.palette.error.main, 0.07),
                    border: `1px solid ${alpha(theme.palette.error.main, 0.2)}`,
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <ReceiptOutlinedIcon sx={{ fontSize: 16, color: 'error.main' }} />
                    <Typography variant="body2" fontWeight={700} color="error.main">
                        Total Expenses
                    </Typography>
                </Box>
                <Typography variant="subtitle1" fontWeight={800} color="error.dark">
                    ₹{totalExpense()}
                </Typography>
            </Box>
        </Box>
    );
};
